import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { getFonts, FontResponseType, FontRequestType } from '../api/font'
import axios from 'axios'

export type FontState = {
   isPristine: boolean
   isFetching: boolean
   data: FontResponseType | null
}

const initialState: FontState = {
   isPristine: true,
   isFetching: false,
   data: null,
}


export const getFontsThunk = createAsyncThunk(
   'getFonts',
   async (
      request: FontRequestType,
      { rejectWithValue },
   ) => {
      try {
         return getFonts(request)
      } catch (error) {
         if (axios.isAxiosError(error)) {
            return rejectWithValue(error?.response?.data)
         }
         return rejectWithValue('unknown error')
      }
   },
)

export const fontsSlice = createSlice({
   name: 'fonts',
   initialState,
   reducers: {
      load: (state, action: PayloadAction<FontResponseType>) => {
         state.isPristine = false
         state.isFetching = false
         state.data = action.payload
      },
   },
   extraReducers(builder) {
      builder.addCase(getFontsThunk.pending, (state) => {
         state.isPristine = false
         state.isFetching = true
      })
      builder.addCase(getFontsThunk.fulfilled, (state, action) => {
         const { payload } = action
         state.isPristine = false
         state.isFetching = false
         state.data = payload
      })
      builder.addCase(getFontsThunk.rejected, (state) => {
         state.isPristine = false
         state.isFetching = false
      })
   },
})

export const { load } = fontsSlice.actions

export default fontsSlice.reducer
